export function commercialReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "GET_ALL_COMM_STATS":            
            return payload;
        
        case "GET_COMM_STATS":            
            return {[payload.commercialID] : payload.stats, ...state};
        
        default:
            return state;
    }
    
}